"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var codeStyle = function codeStyle(_ref) {
  var padded = _ref.padded;
  return {
    'code[class*="language-"]': {
      color: bitcoincom_pkg_theme_1.colors.solid.white,
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: bitcoincom_pkg_theme_1.colors.solid.white,
      background: bitcoincom_pkg_theme_1.colors.solid.comet,
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: padded ? ".5em 0" : 0,
      overflow: "auto"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#2d2d2d",
      padding: ".1em",
      borderRadius: ".3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#999"
    },
    "block-comment": {
      color: "#999"
    },
    prolog: {
      color: "#999"
    },
    doctype: {
      color: "#999"
    },
    cdata: {
      color: "#999"
    },
    punctuation: {
      color: "#ccc"
    },
    tag: {
      color: "#e2777a"
    },
    "attr-name": {
      color: "#e2777a"
    },
    namespace: {
      color: "#e2777a"
    },
    deleted: {
      color: "#e2777a"
    },
    "function-name": {
      color: "#6196cc"
    },
    "boolean": {
      color: "#f08d49"
    },
    number: {
      color: "#f08d49"
    },
    "function": {
      color: "#f08d49"
    },
    property: {
      color: "#f8c555"
    },
    "class-name": {
      color: "#f8c555"
    },
    constant: {
      color: "#f8c555"
    },
    symbol: {
      color: "#f8c555"
    },
    selector: {
      color: "#cc99cd"
    },
    important: {
      color: "#cc99cd",
      fontWeight: "bold"
    },
    atrule: {
      color: "#cc99cd"
    },
    keyword: {
      color: "#cc99cd"
    },
    builtin: {
      color: "#cc99cd"
    },
    string: {
      color: bitcoincom_pkg_theme_1.colors.solid.caribbeanGreen
    },
    "char": {
      color: bitcoincom_pkg_theme_1.colors.solid.caribbeanGreen
    },
    "attr-value": {
      color: bitcoincom_pkg_theme_1.colors.solid.caribbeanGreen
    },
    regex: {
      color: bitcoincom_pkg_theme_1.colors.solid.caribbeanGreen
    },
    variable: {
      color: bitcoincom_pkg_theme_1.colors.solid.caribbeanGreen
    },
    operator: {
      color: "#67cdcc"
    },
    entity: {
      color: "#67cdcc",
      cursor: "help"
    },
    url: {
      color: "#67cdcc"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    inserted: {
      color: "green"
    }
  };
};

exports["default"] = codeStyle;